import { render } from "./SamplingPointListSupport.component.vue?vue&type=template&id=33de318e&scoped=true&ts=true"
import script from "./SamplingPointListSupport.component.vue?vue&type=script&lang=ts"
export * from "./SamplingPointListSupport.component.vue?vue&type=script&lang=ts"

import "./SamplingPointListSupport.component.vue?vue&type=style&index=0&id=33de318e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33de318e"]])

export default __exports__